import {useSelector} from 'react-redux'

import cn from '../../../common/className.js'
import HeaderDropdown from '../../../common/components/List/HeaderDropdown.js'
import {showPrintPickPackModal} from '../../../common/components/Modal/PrintPickPackModal.js'
import {showAddressLabelModal} from '../Modals/AddressLabelModal.js'
import {
  activeOrderNumbersSelector,
  batchReferenceIDSelector,
} from '../orderListSelectors.js'
import {showOrderLineLabelModal} from '../Modals/OrderLineLabelModal.js'
import {selectedOrderLineIDsSelector} from '../../OrderDetailPage/orderDetailSelectors.js'

export default function PrintDropdown({
  selectedOrderNumbers,
  className,
  orderActions,
}) {
  const batchReferenceID = useSelector(batchReferenceIDSelector)
  const activeOrderNumbers = useSelector(activeOrderNumbersSelector)
  const selectedLineIDs = useSelector(selectedOrderLineIDsSelector)

  if (batchReferenceID) {
    return null
  }

  return (
    <HeaderDropdown
      label="Print"
      className={cn`margin-left-3 ${className}`}
      dropdown="DROPDOWN_ORDER_LIST_PRINT_ACTIONS"
    >
      <li className="list__item list__item--dropdown">
        <button
          className="btn--link list__link--dropdown"
          type="button"
          onClick={() => showPrintPickPackModal(activeOrderNumbers)}
        >
          Pick/Pack Lists
        </button>
      </li>
      {orderActions.address_labels && (
        <li className="list__item list__item--dropdown">
          <button
            className="btn--link list__link--dropdown meta-printdropdown-button-address-label-modal"
            type="button"
            onClick={() => showAddressLabelModal(selectedOrderNumbers)}
          >
            Address Labels
          </button>
        </li>
      )}
      <li className="list__item list__item--dropdown">
        <button
          className="btn--link list__link--dropdown meta-printdropdown-button-line-label-modal"
          type="button"
          onClick={() =>
            showOrderLineLabelModal({
              orderNumbers: selectedOrderNumbers,
              lineIDs: selectedLineIDs,
            })
          }
        >
          Line Labels
        </button>
      </li>
    </HeaderDropdown>
  )
}
